import { poll } from 'ggApp/utils/promise';
import { confirmPayPalPaymentMethod } from './groverApiPayPal';
import { isPaypalPaymentMethodReady } from './paymentMethod';

const pollingInterval = 4000; // ms
const pollingTries = 5;

export default function waitForPayPalPaymentMethodReady(orderNumber, data) {
    return poll(
        () => confirmPayPalPaymentMethod(orderNumber, data),
        isPaypalPaymentMethodReady,
        pollingInterval,
        pollingTries,
    );
}
